import { useState } from 'react';
import './App.css';

function App() {
  const [showDetail, setShowDetail] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFadingIn, setIsFadingIn] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  const [imageTransition, setImageTransition] = useState('none');

  const bonaireImages = [
    '/bonairetrip/1607267921691122790.jpeg',
    '/bonairetrip/3545185900073708000.JPG',
    '/bonairetrip/6037100592397279201.jpeg'
  ];

  const domesticImages = [
    '/domestictrips/IMG_0876_Original.JPEG',
    '/domestictrips/IMG_4280_Original.JPEG',
    '/domestictrips/IMG_6950_Original.JPEG',
    '/domestictrips/IMG_8116_Original.JPG',
    '/domestictrips/IMG_8183.JPG',
    '/domestictrips/IMG_8708_Original.JPG'
  ];

  const asiaImages = [
    '/asiatrip/IMG_2066_Original.JPEG',
    '/asiatrip/IMG_6284_Original.JPEG'
  ];

  const handleIconClick = (iconType) => {
    setIsAnimating(true);
    setCurrentImageIndex(0);
    setImageTransition('none');
    setTimeout(() => {
      setShowDetail(true);
      setSelectedIcon(iconType);
      setIsAnimating(false);
    }, 500);
  };

  const handleBackClick = () => {
    setIsFadingIn(true);
    setShowDetail(false);
    setSelectedIcon(null);
    setCurrentImageIndex(0);
    setTimeout(() => {
      setIsFadingIn(false);
    }, 500);
  };

  const getCurrentImages = () => {
    if (selectedIcon === 'bonaire') return bonaireImages;
    if (selectedIcon === 'usa') return domesticImages;
    if (selectedIcon === 'asia') return asiaImages;
    return [];
  };

  const handleNextImage = () => {
    const images = getCurrentImages();
    setImageTransition('slide-out-left');
    setTimeout(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
      setImageTransition('slide-in-right');
      setTimeout(() => {
        setImageTransition('none');
      }, 300);
    }, 150);
  };

  const handlePrevImage = () => {
    const images = getCurrentImages();
    setImageTransition('slide-out-right');
    setTimeout(() => {
      setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
      setImageTransition('slide-in-left');
      setTimeout(() => {
        setImageTransition('none');
      }, 300);
    }, 150);
  };

  return (
    <div 
      className="App"
      style={{
        minHeight: '100vh',
        backgroundImage: 'url(/images/newmountainbackground.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        position: 'relative'
      }}
    >
      {showDetail && (
        <button 
          className="back-arrow fade-in"
          onClick={handleBackClick}
          aria-label="Back to home"
        >
          ←
        </button>
      )}
      
      <div className={`icons-grid ${isAnimating ? 'fade-out' : ''} ${isFadingIn ? 'fade-in' : ''} ${showDetail ? 'hidden' : ''}`}>
        <div className="icon-container" onClick={() => handleIconClick('bonaire')}>
          <img 
            src="/icons/bonaireicon.png" 
            alt="Bonaire Icon" 
            className="corkboard-icon fish-icon"
          />
          <span className="icon-label">Bonaire</span>
        </div>
        <div className="icon-container paraglider-container" onClick={() => handleIconClick('europe')}>
          <img 
            src="/icons/paraglideicon.png" 
            alt="Paraglide Icon" 
            className="corkboard-icon paraglider-icon"
          />
          <span className="icon-label">Europe</span>
        </div>
        <div className="icon-container" onClick={() => handleIconClick('usa')}>
          <img 
            src="/icons/usflagicon.png" 
            alt="US Flag Icon" 
            className="corkboard-icon flag-icon"
          />
          <span className="icon-label">United States</span>
        </div>
        <div className="icon-container" onClick={() => handleIconClick('asia')}>
          <img 
            src="/icons/mbsicon.png" 
            alt="Asia Icon" 
            className="corkboard-icon asia-icon"
          />
          <span className="icon-label">Asia</span>
        </div>
      </div>
      
      {showDetail && selectedIcon === 'bonaire' && (
        <div className="carousel-container fade-in">
          <button className="carousel-arrow carousel-arrow-left" onClick={handlePrevImage}>
            ‹
          </button>
          <div className="carousel-image-wrapper">
            <img 
              src={bonaireImages[currentImageIndex]} 
              alt={`Bonaire trip ${currentImageIndex + 1}`}
              className={`carousel-image ${imageTransition}`}
            />
          </div>
          <button className="carousel-arrow carousel-arrow-right" onClick={handleNextImage}>
            ›
          </button>
        </div>
      )}
      
      {showDetail && selectedIcon === 'usa' && (
        <div className="carousel-container fade-in">
          <button className="carousel-arrow carousel-arrow-left" onClick={handlePrevImage}>
            ‹
          </button>
          <div className="carousel-image-wrapper">
            <img 
              src={domesticImages[currentImageIndex]} 
              alt={`United States trip ${currentImageIndex + 1}`}
              className={`carousel-image ${imageTransition}`}
            />
          </div>
          <button className="carousel-arrow carousel-arrow-right" onClick={handleNextImage}>
            ›
          </button>
        </div>
      )}
      
      {showDetail && selectedIcon === 'asia' && (
        <div className="carousel-container fade-in">
          <button className="carousel-arrow carousel-arrow-left" onClick={handlePrevImage}>
            ‹
          </button>
          <div className="carousel-image-wrapper">
            <img 
              src={asiaImages[currentImageIndex]} 
              alt={`Asia trip ${currentImageIndex + 1}`}
              className={`carousel-image ${imageTransition}`}
            />
          </div>
          <button className="carousel-arrow carousel-arrow-right" onClick={handleNextImage}>
            ›
          </button>
        </div>
      )}
      
      {!showDetail && (
        <div className="sunflower-container" onClick={() => setShowMessage(true)}>
          <img 
            src="/icons/sunflowernew.png" 
            alt="Sunflower Icon" 
            className="sunflower-icon"
          />
        </div>
      )}
      
      {showMessage && (
        <div className="message-modal-overlay" onClick={() => setShowMessage(false)}>
          <div className="message-modal" onClick={(e) => e.stopPropagation()}>
            <button className="message-close" onClick={() => setShowMessage(false)}>×</button>
            <div className="message-content">
              <p>Dear Mom,</p>
              <p>Happy 48th birthday! I love you very much and wanted to share with you this website to remember your favorite saying and our family adventures. Everthing that has happened this year was made possible by your love and support. I love you very much mom, and I can't wait to see what we do next year!</p>
              <p>Love,<br />Phillip</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
